<template>
    <ReactPage>
      <shipping-receipt-report-page></shipping-receipt-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "ShippingReceiptReport",
    components: {
      ReactPage
    }
  }
  </script>